import { CTA, Arrow, serif, shell, Eyebrow, Title } from "../components/CommonComponents";

export default function RelatedPrograms({ course }) {
  const programs = course?.relatedPrograms;

  const featured = programs[0];
  const others = programs.slice(1);

  return (
    <section id="related" className="bg-[#071A2F] py-20 text-white sm:py-24 lg:py-28"    >
      <div className={shell}>
        <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <Eyebrow dark>Continue exploring</Eyebrow>
            <Title dark>Related Programs / Explore Other Courses</Title>
          </div>
          <a
            href="/academic-programs"
            className="inline-flex items-center gap-4 text-sm font-bold text-[#D5AD57]"
          >
            View all programmes <Arrow />
          </a>
        </div>
        <div className="mt-12 grid gap-4 md:grid-cols-2 xl:grid-cols-4">
          {course.related.map((x, i) => (
            <a
              href="/academic-programs"
              key={x}
              className="group min-h-[210px] border-l-4 border-l-[#D5AD57] border-y border-r border-white/15 bg-white/[0.04] p-6 transition hover:-translate-y-1 hover:border-[#D5AD57]"
            >
              <span className="text-sm font-bold text-[#D5AD57]">0{i + 1}</span>
              <h3 className={`${serif} mt-12 text-3xl`}>{x}</h3>
              <span className="mt-6 flex items-center gap-3 text-sm text-white/60 group-hover:text-white">
                Explore programme <Arrow />
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
